const AVAILABLE_CLIENTS = [
  "c/libcurl",
  "clojure/clj_http",
  "csharp/httpclient",
  "csharp/restsharp",
  "dart/http",
  "go/native",
  "http/http1.1",
  "java/asynchttp",
  "java/nethttp",
  "java/okhttp",
  "java/unirest",
  "js/axios",
  "js/fetch",
  "js/jquery",
  "js/ofetch",
  "js/xhr",
  "kotlin/okhttp",
  "node/axios",
  "node/fetch",
  "node/ofetch",
  "node/undici",
  "objc/nsurlsession",
  "ocaml/cohttp",
  "php/curl",
  "php/guzzle",
  "powershell/restmethod",
  "powershell/webrequest",
  "python/python3",
  "python/requests",
  "python/httpx_sync",
  "python/httpx_async",
  "r/httr",
  "ruby/native",
  "rust/reqwest",
  "shell/curl",
  "shell/httpie",
  "shell/wget",
  "swift/nsurlsession"
];
export {
  AVAILABLE_CLIENTS
};
//# sourceMappingURL=snippetz.js.map
